//#region src/hardware_read_method.ts
const HardwareReadMethod = {
	Manual: "manual",
	Msr: "msr",
	Hid: "hid",
	Scanner: "scanner",
	Terminal: "terminal"
};
//#endregion
export { HardwareReadMethod };

//# sourceMappingURL=hardware_read_method.js.map